/**
 * @file
 * Layout sizing/padding behaviors for layerone (two-column layout, header
 * image, banner, gutters, etc.) that need to re-run on window resize.
 *
 * Requires global.js to be loaded first (Drupal.layerone.getScreenWidth).
 */
(function ($, Drupal) {

  'use strict';

  // A real, directly-usable CSS colour value (hex, rgb()/hsl()/var()/
  // linear-gradient()) rather than one of this theme's legacy class-name
  // colour tokens (e.g. "bg-jet-black"). Mirrors the "css_value" Twig
  // test in layerone_colour_render — see that module for why.
  function isCssValue(value) {
    if (!value) {
      return false;
    }
    return /^#[0-9a-fA-F]{3,8}$/.test(value) || /^(rgb|rgba|hsl|hsla|var|linear-gradient)\(/i.test(value);
  }

  Drupal.behaviors.layeroneLayout = {
    attach: function (context, settings) {

      function setHeights() {
        $('.set-this-height', context).each(function() {
          let height = $(this).height();
          if ($(this).hasClass('max-height-400'))
          if (height > 400) {
            height = 400;
          }
          $(this).css('height', height + 'px');
        });
      }

      function resizeTwoColumnLayout() {

        $('.two-column-layout-container', context).each(function() {
          let screenWidth = Drupal.layerone.getScreenWidth();
          // Heights come from the CSS (the columns stretch to the taller
          // one); this only switches the backgrounds between layouts.
          if (screenWidth > 767) {
            let linearGradient = $(this).data('linear-gradient');
            if (linearGradient !== undefined) {
              $(this).css('background', linearGradient);
            }
            $(this).find('.two-column-layout').css('height', '');
            let backgroundColour1 = $(this).find('.two-column-1').data('background-colour');
            if (backgroundColour1 === undefined) {
              $(this).find('.two-column-1').removeClass(backgroundColour1).addClass('bg-transparent');
            }
            let backgroundColour2 = $(this).find('.two-column-2').data('background-colour');
            if (backgroundColour2 === undefined) {
              $(this).find('.two-column-2').removeClass(backgroundColour2).addClass('bg-transparent');
            }
          } else {
            let linearGradient = $(this).data('linear-gradient');
            if (linearGradient !== undefined) {
              $(this).css('background', 'unset');
            }
            $(this).find('.two-column-layout').css('height', '');
            let backgroundColour1 = $(this).find('.two-column-1').data('background-colour');
            if (backgroundColour1 !== undefined) {
              if (isCssValue(backgroundColour1)) {
                $(this).find('.two-column-1').removeClass('bg-transparent').css('background-color', backgroundColour1);
              }
              else {
                $(this).find('.two-column-1').removeClass('bg-transparent').addClass(backgroundColour1);
              }
            }
            let backgroundColour2 = $(this).find('.two-column-2').data('background-colour');
            if (backgroundColour2 !== undefined) {
              if (isCssValue(backgroundColour2)) {
                $(this).find('.two-column-2').removeClass('bg-transparent').css('background-color', backgroundColour2);
              }
              else {
                $(this).find('.two-column-2').removeClass('bg-transparent').addClass(backgroundColour2);
              }
            }
          }
        });

        $('.paragraph--type--promo-half-half', context).each(function() {
          let screenWidth = Drupal.layerone.getScreenWidth();
          if (screenWidth < 368) {
            $(this).find('img').css('height', '100%').css('width', 'auto');
          }
          else if (screenWidth < 495) {
            $(this).find('img').css('height', 'auto').css('width', '100%');
          }
          else if (screenWidth < 500) {
            $(this).find('img').css('height', '330px').css('width', 'auto');
          }
          else if (screenWidth < 660) {
            $(this).find('img').css('height', 'auto').css('width', '100%');
          }
          else if (screenWidth < 768) {
            $(this).find('img').css('height', 'auto').css('width', '100%');
          }
          if (screenWidth > 767) {
            let containerHeight = $(this).find('.feature-image-wrapper').height();
            let imageHeight = $(this).find('img').height();
            let contentHeight = $(this).find('.feature-details-wrapper').height();
            if (screenWidth >= 1200) {
              contentHeight = contentHeight + 96;
            }
            if (contentHeight > imageHeight || contentHeight === imageHeight) {
              if (screenWidth < 1200) {
                contentHeight = contentHeight + 1;
              }
              $(this).find('img').css('height', contentHeight + 'px').css('width', 'auto');
            }
          }
        });
      }

      // Header image
      function resizeHeaderImage() {
        let headerHeight = $('.paragraph--type--header', context).height();
        if (headerHeight !== 'undefined' && headerHeight > 0) {
          let height = $('.field--name-field-hp-image .field--name-field-media-image', context).height();
          let width = $('.field--name-field-hp-image .field--name-field-media-image', context).width();
          let aspectRatio = width / height;
          let newWidth = headerHeight * aspectRatio;
          let containerWidth = newWidth + 170;
          $('.field--name-field-hp-image', context).css('width', containerWidth);
          $('.field--name-field-hp-image .field--name-field-media-image', context).css('height', headerHeight + 'px').css('width', newWidth + 'px');
        }
      }

      function twoColumLayoutPadding() {
        $('.paragraph--type--two-column-layout').each(function() {
          let linearGradient = $(this).data('linear-gradient');
          if (linearGradient !== undefined) {
            let screenWidth = Drupal.layerone.getScreenWidth();
            if (screenWidth < 768) {
              if ($(this).hasClass('py-grow-4')) {
                $(this).removeClass('py-grow-4').addClass('py-0').addClass('replace-py-grow-4');
              }
            } else {
              if ($(this).hasClass('replace-py-grow-4')) {
                $(this).removeClass('replace-py-grow-4').removeClass('py-0').addClass('py-grow-4');
              }
            }
          }
        });
      }

      function setBannerPadding() {
        let bannerImage = $('#block-layerone-views-block-banner-image-block-1 .image-style-banner');
        if (bannerImage !== undefined) {
          let screenWidth = Drupal.layerone.getScreenWidth();
          if (screenWidth < 568) {
            let bannerPaddingBottom = '369px';
            let bannerHeight = '539px';
            $(bannerImage).css('height', '297px').css('width', 'auto');
            $('#banner.landing-banner').css('padding-bottom', bannerPaddingBottom).css('height', bannerHeight).css('width', 'auto');
          }
          else if (screenWidth < 768) {
            $(bannerImage).css('height', 'auto').css('width', '100%');
            let bannerImageContainer = $('#block-layerone-views-block-banner-image-block-1');
            bannerImageContainer.css('width', '100%').css('right', '0');
            let height = bannerImage.height();
            let paddingBottom = height + 40;
            let bannerPaddingBottom = paddingBottom + 'px';
            let bannerHeight = height + 232;
            let bannerHeightValue = bannerHeight + 'px';
            $('#banner.landing-banner').css('padding-bottom', bannerPaddingBottom).css('height', bannerHeightValue);
          }
          else if (screenWidth <= 845) {
            let bannerImageContainer = $('#block-layerone-views-block-banner-image-block-1');
            bannerImageContainer.css('width', '47vw').css('right', '0');
            $(bannerImage).css('height', 'auto').css('width', '62vw');
            let imageHeight = bannerImage.height();
            let bannerHeightValue = imageHeight + 'px';
            let containerHeight = imageHeight - 40;
            let containerHeightValue = containerHeight + 'px';
            $('#banner.landing-banner').css('height', bannerHeightValue).css('padding-bottom', '40px');
            $('#banner.landing-banner > .container').css('height', containerHeightValue);

          }

          else if (screenWidth <= 901) {
            let bannerImageContainer = $('#block-layerone-views-block-banner-image-block-1');
            bannerImageContainer.css('width', '47vw').css('right', '0');
            $(bannerImage).css('height', 'auto').css('width', '58vw');
            let imageHeight = bannerImage.height();
            let bannerHeightValue = imageHeight + 'px';
            let containerHeight = imageHeight - 40;
            let containerHeightValue = containerHeight + 'px';
            $('#banner.landing-banner').css('height', bannerHeightValue).css('padding-bottom', '40px');
            $('#banner.landing-banner > .container').css('height', containerHeightValue);

          }
          else if (screenWidth <= 940) {
            let bannerImageContainer = $('#block-layerone-views-block-banner-image-block-1');
            bannerImageContainer.css('width', '48vw').css('right', '0');
            $(bannerImage).css('height', 'auto').css('width', '54vw');
            let imageHeight = bannerImage.height();
            let bannerHeightValue = imageHeight + 'px';
            let containerHeight = imageHeight - 40;
            let containerHeightValue = containerHeight + 'px';
            $('#banner.landing-banner').css('height', bannerHeightValue).css('padding-bottom', '40px');
            $('#banner.landing-banner > .container').css('height', containerHeightValue);

          }
          else if (screenWidth < 992) {
            let bannerImageContainer = $('#block-layerone-views-block-banner-image-block-1');
            bannerImageContainer.css('width', '48vw').css('right', '0');
            $(bannerImage).css('height', 'auto').css('width', '52vw');
            let imageHeight = bannerImage.height();
            let bannerHeightValue = imageHeight + 'px';
            let containerHeight = imageHeight - 40;
            let containerHeightValue = containerHeight + 'px';
            $('#banner.landing-banner').css('height', bannerHeightValue).css('padding-bottom', '40px');
            $('#banner.landing-banner > .container').css('height', containerHeightValue);

          }
          else if (screenWidth < 2600) {
            let bannerImageContainer = $('#block-layerone-views-block-banner-image-block-1');
            bannerImageContainer.css('width', '50vw').css('right', '0');
            $(bannerImage)
              .css('height', 'auto')
              .css('width', '50vw')
              .css('position', 'relative');
            let imageHeight = bannerImage.height();
            let bannerHeightValue = imageHeight + 'px';
            let containerHeight = imageHeight - 40;
            let containerHeightValue = containerHeight + 'px';
            $('#banner.landing-banner').css('height', bannerHeightValue).css('padding-bottom', '40px');
            $('#banner.landing-banner > .container').css('height', containerHeightValue);

          }
          else {
            let bannerImage = $('#block-layerone-views-block-banner-image-block-1 .image-style-banner');
            if (bannerImage !== undefined) {
              let bannerImageContainer = $('#block-layerone-views-block-banner-image-block-1');
              bannerImageContainer.css('width', '50vw');
              $(bannerImage)
                .css('height', '650px')
                .css('width', 'auto')
                .css('position', 'absolute')
                .css('right', '0');
              $('#banner.landing-banner').css('height', '650px');
              $('#banner.landing-banner > .container').css('height', '610px');
            }
          }
        }

      }

      function setHeaderPadding() {
        let screenWidth = Drupal.layerone.getScreenWidth();

        if (screenWidth < 768) {
          let paragraphContent = $('.paragraph--type--header-full-width > .container');
          if (paragraphContent.length > 0) {
            let headerImage = $('.paragraph--type--header-full-width img');
            if (headerImage.length > 0) {
              let height = headerImage.height();
              let headerPaddingBottom = height + 'px';
              $(paragraphContent).css('padding-bottom', headerPaddingBottom);
              // $('#header-full-width-content-container').css('min-height', 'unset').css('padding-bottom', '0');
            }
            $('#header-full-width-content-container').css('padding-bottom', '3rem');
          }
        }
        else {
          let paragraphContent = $('.paragraph--type--header-full-width > .container');
          if (paragraphContent.length > 0) {
            let headerImage = $('.paragraph--type--header-full-width img');
            if (headerImage.length > 0) {
              let height = headerImage.height();
              let containerHeight = height + 'px';
              $('#header-full-width-content-container').css('min-height', containerHeight).css('padding-bottom', '3rem');
              $(paragraphContent).css('padding-bottom', '0');
            }
          }
        }
      }

      function adjustPromoLandscapePadding() {
        let screenWidth = Drupal.layerone.getScreenWidth();
        let paragraphContent = $('.paragraph--type--promo-landscape');
        if (paragraphContent.length > 0) {
          let image = $('.paragraph--type--promo-landscape img');
          if (image.length > 0) {
            if (screenWidth < 768) {
              let height = image.height();
              let width = image.width();
              let widthValue = width + 'px';
              $('.promo-landscape-content').css('width', widthValue);
              let topPadding = height - 72;
              let bottomPadding = height - 107;
              let topPaddingValue = topPadding + 'px';
              let bottomPaddingValue = bottomPadding + 'px'
              $('.promo-landscape-container-right').css('padding-top', topPaddingValue);
              $('.promo-landscape-container-left').css('padding-bottom', bottomPaddingValue);
            }
            else if (screenWidth < 992) {
              let paddingValue = 0;
              $('.promo-landscape-content').css('width', '100%');
              $('.promo-landscape-container-right').css('padding-top', paddingValue);
              $('.promo-landscape-container-left').css('padding-bottom', paddingValue);
            }


          }
        }
      }

      function changeGutters() {
        let screenWidth = Drupal.layerone.getScreenWidth();
        if (screenWidth < 576) {
          $(':root').css('--bs-gutter-x', '1.25rem');
        }
        else if (screenWidth >= 576 && screenWidth < 768) {
          $(':root').css('--bs-gutter-x', '1.75rem');
        }
        else {
          $(':root').css('--bs-gutter-x', '2rem');
        }
      }

      // Exposed so other behaviors (e.g. the accordion toggle) can trigger a
      // re-layout after content height changes.
      Drupal.layerone.resizeTwoColumnLayout = resizeTwoColumnLayout;

      resizeHeaderImage();
      resizeTwoColumnLayout();
      twoColumLayoutPadding();
      setBannerPadding();
      setHeaderPadding();
      changeGutters();
      adjustPromoLandscapePadding();
      setHeights();

      window.addEventListener('resize', function(){
        resizeHeaderImage();
        resizeTwoColumnLayout();
        twoColumLayoutPadding();
        setBannerPadding();
        setHeaderPadding();
        changeGutters();
        adjustPromoLandscapePadding();
        setHeights();
      },true);

    }
  };

})(jQuery, Drupal);
